/* Wander Painting — pagination dots for the mobile carousels.
   The swiping itself is CSS scroll-snap; this only builds the dots, keeps the
   active one in sync with scroll position, and scrolls on tap. Dots are only
   meaningful at mobile widths, so everything is gated behind a media query. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function Carousel(track) {
    this.track = track;
    this.dots = document.querySelector('[data-wp-dots="' + track.getAttribute('data-wp-carousel') + '"]');
    if (!this.dots) return;

    this.buttons = [];
    this.onScroll = this.onScroll.bind(this);
    this.sync = this.sync.bind(this);

    this.mq = window.matchMedia(MOBILE);
    // Safari < 14 only has the deprecated listener API.
    if (this.mq.addEventListener) this.mq.addEventListener('change', this.sync);
    else this.mq.addListener(this.sync);

    this.sync();
    track.setAttribute('data-wp-carousel-ready', 'true');
  }

  Carousel.prototype.sync = function () {
    if (this.mq.matches) this.build();
    else this.teardown();
  };

  Carousel.prototype.build = function () {
    var items = this.track.children;
    if (this.buttons.length === items.length) return;

    this.dots.textContent = '';
    this.buttons = [];

    for (var i = 0; i < items.length; i++) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Go to item ' + (i + 1) + ' of ' + items.length);
      btn.addEventListener('click', this.goTo.bind(this, i));
      li.appendChild(btn);
      this.dots.appendChild(li);
      this.buttons.push(btn);
    }

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.setActive(0);
  };

  Carousel.prototype.teardown = function () {
    this.track.removeEventListener('scroll', this.onScroll);
    this.dots.textContent = '';
    this.buttons = [];
  };

  Carousel.prototype.goTo = function (index) {
    var item = this.track.children[index];
    if (!item) return;
    this.track.scrollTo({
      left: item.offsetLeft - this.track.offsetLeft,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  };

  Carousel.prototype.onScroll = function () {
    if (this.frame) return;
    var self = this;
    this.frame = window.requestAnimationFrame(function () {
      self.frame = null;
      self.setActive(self.nearestIndex());
    });
  };

  Carousel.prototype.nearestIndex = function () {
    var items = this.track.children;
    var left = this.track.scrollLeft;
    var best = 0;
    var bestDistance = Infinity;
    for (var i = 0; i < items.length; i++) {
      var distance = Math.abs((items[i].offsetLeft - this.track.offsetLeft) - left);
      if (distance < bestDistance) { bestDistance = distance; best = i; }
    }
    return best;
  };

  Carousel.prototype.setActive = function (index) {
    for (var i = 0; i < this.buttons.length; i++) {
      this.buttons[i].setAttribute('aria-current', i === index ? 'true' : 'false');
    }
  };

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-wp-carousel]:not([data-wp-carousel-ready])');
    for (var i = 0; i < nodes.length; i++) new Carousel(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
